export const sliderItems = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/2043590/pexels-photo-2043590.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/1353503/pexels-photo-1353503.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "AUTUMN COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/3587478/pexels-photo-3587478.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "ELECTRONICS SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/6184464/pexels-photo-6184464.jpeg?auto=compress&cs=tinysrgb&w=600",
    title: "MENS STYLE!",
    cat: "men",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/13660534/pexels-photo-13660534.jpeg?auto=compress&cs=tinysrgb&w=600",
    title: "WOMEN LOVE",
    cat: "women",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/2047905/pexels-photo-2047905.jpeg?auto=compress&cs=tinysrgb&w=600",
    title: "ELECTRONICS",
    cat: "electronics",
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/1021145/pexels-photo-1021145.jpeg?auto=compress&cs=tinysrgb&w=600",
    title: "FOOTWEARS",
    cat: "footwear",
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/214659/pexels-photo-214659.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "BOOKS",
    cat:"books"
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/90946/pexels-photo-90946.jpeg?auto=compress&cs=tinysrgb&w=600",
    
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/2533266/pexels-photo-2533266.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/3685538/pexels-photo-3685538.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/2783873/pexels-photo-2783873.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/2633986/pexels-photo-2633986.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 6,
    img: "https://images.pexels.com/photos/8468017/pexels-photo-8468017.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 7,
    img: "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 8,
    img: "https://images.pexels.com/photos/2313192/pexels-photo-2313192.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
];
